import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateFormatPipe } from './date-format.pipe';
import { JoinPipe } from './join.pipe';
import { NumberFormatPipe } from './number-format.pipe';
import { SubstrPipe } from './substr.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    DateFormatPipe,
    JoinPipe,
    NumberFormatPipe,
    SubstrPipe,
  ],
  exports: [
    DateFormatPipe,
    JoinPipe,
    NumberFormatPipe,
    SubstrPipe,
  ]
})
export class PipesModule { }



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/pipes/pipes.module.ts